"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const heading_1 = require("../../primitives/heading");
const FormSection = ({ title, children }) => ((0, jsx_runtime_1.jsxs)("div", { className: "flex-1 flex-col space-y-[22px]", children: [title ? ((0, jsx_runtime_1.jsx)(heading_1.Heading, { as: "h4", className: "text-[20px] leading-6", children: title })) : null, (0, jsx_runtime_1.jsx)("div", { className: "flex-1 flex-col space-y-[14px]", children: children })] }));
exports.FormSection = FormSection;
